import React from 'react';
import './HomeType.scss';

type HomeTypeButtonProps = {
	homeType: string
	icon: string | ((className: string) => JSX.Element)
	icon2: string | undefined
	homeTypes: string[]
	setHomeTypes: React.Dispatch<React.SetStateAction<string[]>>
}

const HomeTypeButton: React.FC<HomeTypeButtonProps> = ({ homeType, icon, icon2, homeTypes, setHomeTypes }) => {
	return (
		<button className={`${homeTypes.includes(homeType) && 'homesearch-filters__cc-btn--active'} filter__hometypeoption cc-btn--gray cc-btn cc-btn--outline cc-btn--reset-text justify-content-center d-flex flex-wrap justify-items-center align-items-center`}
			onClick={() => {
				if (homeTypes.includes(homeType))
					setHomeTypes(currVal => currVal.filter(type => type !== homeType));
				else
					setHomeTypes(currVal => ([...currVal, homeType]));
			}}>
			<div className='w-100'>
				{typeof icon === 'string' ? <i className={`far fa-${icon}`} /> : icon(homeTypes.includes(homeType) ? 'filter__Icon--active' : 'filter__Icon')}
				{icon2 && <i className={`far fa-${icon2}`} style={{marginLeft: '-3px'}} />}
			</div>
			<div className="text-nowrap">
				{homeType}
			</div>
		</button>
	);
};

export default HomeTypeButton;
